/**
 * @generated SignedSource<<4cee69d4e852074d774d8d0f608fa340>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GeoNewsFeed_item$data = {
  readonly rendered: string | null;
  readonly " $fragmentType": "GeoNewsFeed_item";
};
export type GeoNewsFeed_item$key = {
  readonly " $data"?: GeoNewsFeed_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"GeoNewsFeed_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GeoNewsFeed_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rendered",
      "storageKey": null
    }
  ],
  "type": "NewsfeedItem",
  "abstractKey": null
};

(node as any).hash = "467e1470c0aa901ed73629f2436adc49";

export default node;
